/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { RootStore } from 'src/core/stores/RootStore';
import { ModelType } from 'src/luis/types/ModelType';
import { LuisId } from 'src/luis/types/Resource';
import { CompositeEntityStore } from 'src/luis/types/stores/entities/CompositeEntityStore';
import { SimpleEntityStore } from 'src/luis/types/stores/entities/SimpleEntityStore';
import { PhraseListStore } from 'src/luis/types/stores/features/PhraseListStore';
import { IntentStore } from 'src/luis/types/stores/intents/IntentStore';

/**
 * Updates the given model's feature store house to contain the global phrase lists.
 * @param model can be an intent, composite or ML entities.
 */
export const addGlobalFeaturesToNewModels = (
    model: CompositeEntityStore | SimpleEntityStore | IntentStore,
    appId: LuisId,
    versionId: string,
    rootStore: RootStore
) => {
    const currentAppVersionStore = rootStore.luisAppStoreHouse.findById(appId).appVersionStoreHouse.findById(versionId);
    const globalPhraseLists = currentAppVersionStore.phraseListStoreHouse.items.filter(item => item.isGlobal);

    addGlobalFeaturesToNewModelsHelper(model, globalPhraseLists);
};

const addGlobalFeaturesToNewModelsHelper = (
    model: CompositeEntityStore | SimpleEntityStore | IntentStore,
    globalPhraseLists: PhraseListStore[]
) => {
    globalPhraseLists.forEach(phraseListStore =>
        model.featureStoreHouse.add({ name: phraseListStore.name, id: phraseListStore.id, typeId: 'feature', isRequired: false })
    );

    if (model.typeId === ModelType.Simple) {
        (<SimpleEntityStore>model).children.forEach(child => addGlobalFeaturesToNewModelsHelper(child, globalPhraseLists));
    }
};
